require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-oberloisdorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-oberloisdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-oberloisdorf!./.cache/json/betreuungseinrichtungen-oberpullendorf-oberloisdorf.json
// module id = 987
// module chunks = 231608221292675